import { enableProdMode } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars

import { sentryInit } from '@usheru-hff/sdk/sentry';
import { logClientBootstrapPerformance } from '@usheru-hff/shared/utils';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { currentGitVersion } from './app/version';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.mode == 'prod') {
  enableProdMode();
}

sentryInit(
  environment,
  'https://306e3c6786a9135ff02580bfbcafb1c9@o4508858213859328.ingest.de.sentry.io/4510861827833936',
  currentGitVersion,
  0.2
);

logClientBootstrapPerformance(() => bootstrapApplication(AppComponent, appConfig));
